export const CREATE_SESSION_GROUP_REQUEST = "CREATE_SESSION_GROUP_REQUEST";
export const CREATE_SESSION_GROUP_SUCCESS = "CREATE_SESSION_GROUP_SUCCESS";
export const CREATE_SESSION_GROUP_FAILURE = "CREATE_SESSION_GROUP_FAILURE";

export const RETRIEVE_SESSION_GROUPS_REQUEST = "RETRIEVE_SESSION_GROUPS_REQUEST";
export const RETRIEVE_SESSION_GROUPS_SUCCESS = "RETRIEVE_SESSION_GROUPS_SUCCESS";
export const RETRIEVE_SESSION_GROUPS_FAILURE = "RETRIEVE_SESSION_GROUPS_FAILURE";
